/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ThirdParty} from '../../../_models/third-party';
import {AuthService} from '../../../_services/auth.service';
import {ThirdPartyService} from '../../../_services/third-party.service';
import {I18nService} from '../../../_services/i18n.service';
import {ToastrService} from 'ngx-toastr';
import {EQ} from '../../../_enums/operators';
import {DEFAULT, EMBEDDED} from '../../../_enums/serializer-groups';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Helpers} from '../../../helpers';

@Component({
  selector: 'app-display-third-parties',
  templateUrl: './display-third-parties.component.html',
  styleUrls: ['./display-third-parties.component.scss']
})
export class DisplayThirdPartiesComponent implements OnInit, OnChanges {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                             COMPONENT OUTPUTS                                                                                      ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  @Output() updated = new EventEmitter<ThirdParty[]>();

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PROPERTIES                                                                                            ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public data: ThirdParty[] = [];

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(private authService: AuthService, private dataService: ThirdPartyService, private i18n: I18nService, private toastr: ToastrService) {
  }

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadData();
  }

  private loadData() {
    if (this.authService.currentUser) {
      this.dataService.find({
        filter: ['user.id', EQ, this.authService.currentUser.id],
        serializerGroups: [DEFAULT, EMBEDDED]
      }).subscribe((res: HttpResponse<ThirdParty[]>) => {
        this.data = res.body;
        this.updated.emit(this.data);
      }, (err: HttpErrorResponse) => this.handleError(err));
    }
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              PRIVATE METHODS                                                                                       ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  private handleError(err: HttpErrorResponse): void {
    Helpers.setLoading(false);
    this.toastr.error(`${err.status} - ${this.i18n.get(err.status)}`);
  }
}
